var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useEffect, useRef } from 'react';
import { create } from '@lottiefiles/lottie-interactivity';
var LottieAnimation = function (props) {
    var lottieReference = useRef(null);
    useEffect(function () {
        var _a;
        if (props.isMobile === true) {
            (_a = document === null || document === void 0 ? void 0 : document.getElementById('long-hero-video-scroll-animation')) === null || _a === void 0 ? void 0 : _a.addEventListener('scrollTriggerLongHeroEnter', function () {
                playMobileAnimation();
            });
        }
    }, []);
    var playMobileAnimation = function () {
        if (lottieReference && lottieReference.current && props.isMobile === true) {
            lottieReference.current.play();
        }
        else {
            setTimeout(function () {
                playMobileAnimation();
            }, 100);
        }
    };
    useEffect(function () {
        if (lottieReference && lottieReference.current && props.isMobile !== true) {
            lottieReference.current.addEventListener('ready', function () {
                var totalEndFrames = 300;
                var interactivityObject = create({
                    mode: 'scroll',
                    player: "#" + props.id,
                    speed: 2,
                    container: "#long-hero-video-scroll-container",
                    actions: [
                        {
                            visibility: [0, 0.5],
                            type: 'seek',
                            frames: [0, totalEndFrames],
                        },
                    ],
                });
                lottieReference.current.addEventListener('frame', function (eve) {
                    if (eve.detail.seeker > 166 && interactivityObject) {
                        interactivityObject.player.stop();
                        lottieReference.current.stop();
                    }
                });
            });
        }
        else if (props.isMobile === true &&
            lottieReference &&
            lottieReference.current) {
            lottieReference.current.addEventListener('complete', function () {
                lottieReference.current.remove();
            });
        }
    }, []);
    return (_jsx("div", __assign({ className: "h-screen " + (props.isMobile ? 'absolute' : 'relative lg:w-1/2'), id: "long-hero-video-scroll-container", style: {
            bottom: props.isMobile ? '-50%' : 'unset',
            right: props.isMobile ? 'unset' : 'unset',
        } }, { children: _jsx("div", __assign({ className: "pointer-events-none z-20 lg:absolute lg:-left-1/2", style: props.isMobile
                ? {
                    bottom: 'unset',
                }
                : {}, id: "long-hero-video-scroll-animation" }, { children: _jsx("lottie-player", { id: props.id, ref: lottieReference, src: JSON.stringify(props.lottieFile), mode: "scroll", style: {
                    minHeight: '100vh',
                    width: props.isMobile ? '140vw' : '90vw',
                    margin: 'auto',
                } }, props.lottieFile) }), void 0) }), void 0));
};
export default LottieAnimation;
